export default "__VITE_ASSET__C_vM4xp2__"